import React from "react";
import clsx from "clsx";

interface SectionContainerProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  fullWidth?: boolean;
  fullWidthBg?: boolean;
  bgClassName?: string;
}

const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  className = "",
  id,
  fullWidth = false,
  fullWidthBg = false,
  bgClassName = "",
}) => {
  const innerClass = clsx(
    "py-16 md:py-24",
    !fullWidth && "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
    fullWidthBg && "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
    className
  );

  if (fullWidthBg) {
    return (
      <section id={id} className={clsx("w-full", bgClassName)}>
        <div className={innerClass}>{children}</div>
      </section>
    );
  }

  return (
    <section id={id} className={innerClass}>
      {children}
    </section>
  );
};

export default SectionContainer;
